import { render, staticRenderFns } from "./NotificationOTP.vue?vue&type=template&id=0b0eb75e&scoped=true"
import script from "./NotificationOTP.vue?vue&type=script&lang=js"
export * from "./NotificationOTP.vue?vue&type=script&lang=js"
import style0 from "./NotificationOTP.vue?vue&type=style&index=0&id=0b0eb75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0eb75e",
  null
  
)

export default component.exports